import React from "react";
import { SpinnerWrapper } from "./SpinnerLoading.styles";
import loading from "../../../assets/icons/loading.svg";

export const SpinnerLoading: React.FC = () => (
  <SpinnerWrapper>
    <img src={loading} alt="Loading" />
  </SpinnerWrapper>
);
